
    var riot = require('riot')
    
riot.tag2('memgraph', '<linechart data="{data}" height="{300}" options="{options}"></linechart>', '', '', function(opts) {
this.data = {
  labels: [],
  datasets: [
    {
      label: "Heap Size",
      pointRadius: 1,
      lineTension: 0.3,
      spanGaps: true,
      showLine: true,
      borderWidth: 1,
      borderColor: "rgba(75,192,240,1)",
      backgroundColor: "rgba(75,192,240,0.1)",
      data: []
    }, {
      label: "Free Bytes",
      pointRadius: 1,
      borderWidth: 1,
      borderColor: "rgba(255,0,0,0.4)",
      backgroundColor: "rgba(255,0,0,0.1)",
      data: []
    }, {
      label: "Unmapped Bytes",
      lineTension: 0.5,
      spanGaps: true,
      showLine: true,
      pointRadius: 1,
      borderWidth: 1,
      borderColor: "rgba(250,170,0,1)",
      backgroundColor: "rgba(250,170,0,0.1)",
      data: []
    }, {
      label: "Bytes Since GC",
      pointRadius: 1,
      lineTension: 0.5,
      spanGaps: true,
      showLine: true,
      borderWidth: 1,
      borderColor: "rgba(230,230,0,1)",
      backgroundColor: "rgba(230,230,0,0.1)",
      data: []
    }, {
      label: "Total Bytes",
      pointRadius: 1,
      lineTension: 0.5,
      spanGaps: true,
      showLine: true,
      borderWidth: 1,
      borderColor: "rgba(30,240,30,1)",
      backgroundColor: "rgba(30,240,30,0.1)",
      data: []
    }
  ]
};

this.options = {
  scales: {
    xAxes: [
      {
        type: "time",
        position: "bottom",
        time: {
          tooltipFormat: "HH:mm D MMM YYYY",
          displayFormat: "HH:mm"
        }
      }
    ],
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
          callback: function(label, index, labels) {
            return label.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          }
        }
      }
    ]
  }
};

this.on("mount", function() {
  this.loadall();
  return setInterval((function(_this) {
    return function() {
      return _this.loadlast();
    };
  })(this), 10000);
});

this.loadall = (function(_this) {
  return function() {
    var xhr;
    xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function() {
      var er;
      if (xhr.readyState === 4) {
        try {
          _this.stats = JSON.parse(xhr.responseText);
          return _this.update();
        } catch (error) {
          er = error;
          return console.log("error getting logs");
        }
      }
    };
    xhr.open('GET', "/duocms/api/logs/memory", true);
    return xhr.send();
  };
})(this);

this.loadlast = (function(_this) {
  return function() {
    var xhr;
    xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function() {
      var er;
      if (xhr.readyState === 4) {
        try {
          _this.stats.push(JSON.parse(xhr.responseText));
          return _this.update();
        } catch (error) {
          er = error;
          return console.log("error getting logs");
        }
      }
    };
    xhr.open('GET', "/duocms/api/logs/memory/last", true);
    return xhr.send();
  };
})(this);

this.on("update", function() {
  var avg, i, key, lastcpu, lastdsk, lastmem, len, ref, results, val;
  lastmem = 0;
  lastcpu = 0;
  lastdsk = 0;
  avg = 15;
  if (this.stats) {
    ref = this.stats;
    results = [];
    for (key = i = 0, len = ref.length; i < len; key = ++i) {
      val = ref[key];
      this.data.labels[key] = val.when;
      this.data.datasets[0].data[key] = val.heap_size;
      this.data.datasets[1].data[key] = val.free_bytes;
      this.data.datasets[2].data[key] = val.unmapped_bytes;
      this.data.datasets[3].data[key] = val.bytes_since_gc;
      results.push(this.data.datasets[4].data[key] = val.total_bytes);
    }
    return results;
  }
});
});
riot.tag2('linechart', '<canvas name="canv" height="{opts.height || 400}" width="{opts.width || 400}"></canvas>', 'linechart{display:block;}', '', function(opts) {
var Chart;

Chart = require('chart.js');

this.chart = null;

this.on('mount', function() {
  var ctx;
  Chart.defaults.global.responsive = true;
  ctx = this.canv.getContext("2d");
  return this.chart = new Chart(ctx, {
    type: "line",
    data: opts.data,
    options: opts.options
  });
});

this.on('update', (function(_this) {
  return function() {
    if (_this.chart) {
      return _this.chart.update();
    }
  };
})(this));
});
    
  